module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2ca979d09b271f95782a44beecd7e94e.png";